<template>
  <div class="flex items-center">
    <h5>{{ assessment.title }}</h5>
    <div class="flex items-center">
      <div>
        <button
          v-if="hasTeacherPermissionsInCourse"
          class="sample text-gray-500"
          :class="[Number(count) === 0 ? 'opacity-50' : '']"
          @click="removePoint"
          :disabled="Number(count) === 0"
        >
          <i class="fa-solid fa-angle-left mr-1"></i>
        </button>
        <input
          @input="inputed"
          @blur="saveAssessment"
          v-model="count"
          :centeredText="true"
          :error="count === ''"
          :disabled="
            !hasTeacherPermissionsInCourse ||
            $route.params.courseID === $store.state.course_sample_id
          "
          class="w-12 h-8 rounded-md text-center bg-white border-solid border-gray-200 border outline-none"
          :class="!hasTeacherPermissionsInCourse ? 'bg-gray-50' : 'bg-white'"
        />
        <button
          v-if="hasTeacherPermissionsInCourse"
          class="sample text-gray-500"
          :class="[Number(count) === pointCap ? 'opacity-50' : '']"
          @click="addPoint"
          :disabled="pointCap ? Number(count) === pointCap : false"
        >
          <i class="fa-solid fa-angle-right ml-1"></i>
        </button>
      </div>
    </div>
    <div v-if="!hasTeacherPermissionsInCourse && is_summary">{{ count }}</div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import { mapGetters } from 'vuex';
  export default Vue.extend({
    data() {
      return {
        count: 0,
        point_scale: 0,
      };
    },
    props: {
      assessment: {
        type: Object,
        default() {
          return {};
        },
      },
      pointCap: {
        type: Number,
        default: null,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      is_summary: {
        type: Boolean,
        default: false,
      },
    },
    watch: {
      assessment(mutation) {
        this.count = mutation.value;
      },
    },
    computed: {
      ...mapGetters(['hasTeacherPermissionsInCourse', 'getCourseDetail']),
      countCheck: function () {
        const isBiggerThanZero = Number(this.count) > 0;
        if (isBiggerThanZero) return this.count;
        return 'Score';
      },
    },
    methods: {
      inputed: function () {
        if (this.count === '.') this.count = '';
        if (isNaN(this.count)) {
          this.count = this.count.slice(0, -1);
        } else this.count = this.count.trim();
        if (this.count < 0) this.count = 0;
        if (this.pointCap && this.count > this.pointCap)
          this.count = this.pointCap;
      },
      removePoint: function () {
        if (this.count === '') {
          this.count = '0';
          return;
        }
        this.count = Number.parseFloat(this.count);
        if (this.count < 1) {
          this.count = '0';
          return;
        }
        this.count = String(this.count);
        let decimal_places = 0;
        if (this.count.split('.')[1])
          decimal_places = this.count.split('.')[1].length;
        this.count = Number.parseFloat(this.count);
        this.count -= 1;
        this.count_demo -= 1;
        this.count = String(this.count.toFixed(decimal_places));
        if (this.count < 0) this.count = 0;
        this.saveAssessment();
      },
      addPoint: function () {
        if (this.count === '') {
          this.count = 1;
          return;
        }
        let decimal_places = 0;
        this.count = String(this.count);
        if (this.count.split('.')[1])
          decimal_places = this.count.split('.')[1].length;
        this.count = Number.parseFloat(this.count);
        this.count_demo += 1;
        this.count += 1;
        if (this.pointCap && this.count > this.pointCap) {
          this.count = this.pointCap;
        }
        this.count = String(this.count.toFixed(decimal_places));
        this.saveAssessment();
      },
      saveAssessment: function () {
        if (this.count == this.assessment.value) return;
        const assessment = {
          tag: this.assessment.tag,
          value: this.count,
        };
        this.$emit('saveAssessment', assessment);
      },
    },
    mounted() {
      this.count = this.assessment.value;
    },
  });
</script>



// WEBPACK FOOTER //
// liveDiscussionPointComponent.vue?5cd96dcf